// extracted by mini-css-extract-plugin
module.exports = {"button":"_3JZhRODGzyPthUCOsc0rvx","icon":"BY-gNB40XJ4vexz38RnSH"};